import React from "react";
import { Link } from "react-router-dom";
import { PawPrint, Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS } from "@/data/site";

const linkCls = "text-sm text-white/70 hover:text-white transition-colors duration-200 text-left";

export const Footer = () => {
  const scrollTo = (id) => {
    if (window.location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.location.href = `/#${id}`;
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-[#2A362D] text-white mt-0">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-10 h-10 rounded-full bg-primary flex items-center justify-center"><PawPrint className="w-5 h-5" /></span>
            <span className="font-heading text-2xl font-semibold">{BUSINESS.name}</span>
          </div>
          <p className="text-sm text-white/70 leading-relaxed max-w-xs">
            Personal, home-style pet care for dogs and cats. Family-operated and dependable.
          </p>
          {/* social icons removed */}
        </div>

        <div>
          <h4 className="font-heading text-lg mb-4">Contact</h4>
          <ul className="space-y-3">
            <li className="flex items-center gap-2.5 text-sm text-white/70"><MapPin className="w-4 h-4 text-primary shrink-0" /> Serving {BUSINESS.serviceArea}</li>
            <li><a href={`tel:${BUSINESS.phoneRaw}`} className="flex items-center gap-2.5 text-sm text-white/70 hover:text-white transition-colors"><Phone className="w-4 h-4 text-primary shrink-0" /> {BUSINESS.phoneDisplay}</a></li>
            <li><a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2.5 text-sm text-white/70 hover:text-white transition-colors"><Mail className="w-4 h-4 text-primary shrink-0" /> {BUSINESS.email}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-lg mb-4">Explore</h4>
          <ul className="space-y-2.5">
            <li><button onClick={() => scrollTo("services")} className={linkCls}>Services</button></li>
            <li><button onClick={() => scrollTo("gallery")} className={linkCls}>Gallery</button></li>
            <li><button onClick={() => scrollTo("faq")} className={linkCls}>Frequently Asked Questions</button></li>
            <li><button onClick={() => scrollTo("contact")} className={linkCls}>Contact</button></li>
            <li><Link to="/merchandise" className={linkCls}>Merchandise</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-lg mb-4">Policies</h4>
          <ul className="space-y-2.5">
            <li><Link to="/policies/agreement" className={`${linkCls} font-bold text-white/90`}>Pet Care Agreement (signature required)</Link></li>
            <li><Link to="/policies/emergency" className={`${linkCls} font-bold text-white/90`}>Emergency Care Authorization (signature required)</Link></li>
            <li><Link to="/policies/privacy" className={linkCls}>Privacy Policy</Link></li>
            <li><Link to="/policies/terms" className={linkCls}>Terms and Conditions</Link></li>
            <li><Link to="/policies/cancellation" className={linkCls}>Cancellation Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} {BUSINESS.name}. Serving {BUSINESS.serviceArea}.</p>
          <p className="text-xs text-white/40">Home address kept private — general service area shown only.</p>
        </div>
      </div>
    </footer>
  );
};
